import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewDashboard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 4c0-.232 0-.348.01-.446A2 2 0 0 1 3.554 1.76c.098-.01.214-.01.446-.01h2c.232 0 .348 0 .446.01A2 2 0 0 1 8.24 3.554c.01.098.01.214.01.446s0 .348-.01.446A2 2 0 0 1 6.446 6.24c-.098.01-.214.01-.446.01H4c-.232 0-.348 0-.446-.01A2 2 0 0 1 1.76 4.446c-.01-.098-.01-.214-.01-.446Zm10 .95c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.428-.218.988-.218 2.108-.218h.1c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108v2.1c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218h-.1c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108v-2.1Zm-10 8c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.428-.218.988-.218 2.108-.218h.1c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108v2.1c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218h-.1c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108v-2.1Zm10 3.05c0-.232 0-.348.01-.446a2 2 0 0 1 1.794-1.794c.098-.01.214-.01.446-.01h2c.232 0 .348 0 .446.01a2 2 0 0 1 1.794 1.794c.01.098.01.214.01.446s0 .348-.01.446a2 2 0 0 1-1.794 1.794c-.098.01-.214.01-.446.01h-2c-.232 0-.348 0-.446-.01a2 2 0 0 1-1.794-1.794c-.01-.098-.01-.214-.01-.446Z"
	})]
});
const ForwardRef = forwardRef(SvgViewDashboard);
export { ForwardRef as ReactComponent };
